import React from 'react';
import { ImageUploadingIcon } from '../../../../../utils/SVGIcon';

function PackageItems({
    isLoading,
    applicationPackageList,
    handelSetApplicationPackageId,
    formData,
    isSelectedApplication
}) {
    console.log(isLoading, isSelectedApplication);
    if (isLoading && !applicationPackageList?.length) {
        return (
            <li className="py-2 text-center text-primary-700 text-lg h-full flex justify-center items-center">
                <ImageUploadingIcon />
            </li>
        );
    }

    if (!isLoading && isSelectedApplication && applicationPackageList?.length > 0) {
        return applicationPackageList?.map((item) => (
            <li key={item?.packageId} className="bg-primary-100 rounded-10">
                <button
                    type="button"
                    className="flex justify-between items-center w-full p-3 py-2"
                    onClick={() => handelSetApplicationPackageId(item)}
                >
                    <div className="flex items-center">
                        <input
                            checked={formData?.PackageId === item?.packageId}
                            type="radio"
                            name="PackageSelection"
                            onChange={() => handelSetApplicationPackageId(item)}
                            className="mr-1 checked:bg-red-700"
                        />
                        <span>{item?.title}</span>
                    </div>
                    <div>
                        <span>{item?.text}</span>
                    </div>
                </button>
            </li>
        ));
    }

    if (!isLoading && isSelectedApplication && applicationPackageList?.length === 0) {
        return (
            <li className="py-2 text-center text-primary-700 text-lg h-full flex justify-center items-center">
                No pricing found for this application or user current currency!
            </li>
        );
    }
    return (
        <li className="py-2 text-center text-primary-700 text-lg h-full flex justify-center items-center">
            Please select application to see package list
        </li>
    );
}

function PackageInfo({
    isLoading,
    applicationPackageList,
    handelSetApplicationPackageId,
    formData,
    isSelectedApplication
}) {
    return (
        <div className="mb-2">
            <h2 className="mb-2 font-medium">Pricing:</h2>
            <div className="h-60 bg-secondary-50 p-2 rounded-10 ">
                <ul className=" flex flex-col h-full gap-2 overflow-y-auto custom-scrollbar">
                    <PackageItems
                        isLoading={isLoading}
                        applicationPackageList={applicationPackageList}
                        handelSetApplicationPackageId={handelSetApplicationPackageId}
                        formData={formData}
                        isSelectedApplication={isSelectedApplication}
                    />
                </ul>
            </div>
        </div>
    );
}

export default PackageInfo;
